"use strict";

exports.__esModule = true;
exports.default = void 0;

var _styles = require("@material-ui/core/styles");

const theme = (0, _styles.createMuiTheme)({
  typography: {
    fontSize: "14",
    fontFamily: ['"Akkurat"', '"sans-serif"'].join(',')
  },
  h2: {
    fontSize: "18",
    lineHeight: "1"
  }
});
var _default = theme;
exports.default = _default;
module.exports = exports.default;